"use client";
import * as React from "react";
const SvgVisibilityOnOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 2a7.1 7.1 0 0 1 6.42 4A7.1 7.1 0 0 1 8 10a7.1 7.1 0 0 1-6.42-4A7.1 7.1 0 0 1 8 2M8 .54A8.6 8.6 0 0 0 0 6a8.6 8.6 0 0 0 16 0A8.6 8.6 0 0 0 8 .54m0 3.64A1.82 1.82 0 1 1 8 7.8a1.82 1.82 0 0 1 0-3.63m0-1.46A3.3 3.3 0 0 0 4.73 6 3.3 3.3 0 0 0 8 9.27 3.3 3.3 0 0 0 11.27 6 3.3 3.3 0 0 0 8 2.71" }));
export {
  SvgVisibilityOnOutlined as default
};
